﻿export function getQuestionnaireResponseScore(submitted: boolean, scoreEnabled: boolean, scoreValue: number | undefined, notEnabledString: string) {
    if (!submitted) return "";
    if (!scoreEnabled) return notEnabledString;
    if (scoreValue === 0) {
        return "0 %";
    }
    return scoreValue ? `${scoreValue} %` : "";
}
